// convert byte array
const arrayBufferFromBase64 = (data) => {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

const saveFile = (name, byte) => {
  var blob = new Blob([byte]);
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  document.body.appendChild(link);
  var fileName = name;
  link.download = fileName;
  link.click();
};

const openFile = (byte, type = 'application/pdf', name = null) => {
  var blob = new Blob([byte], { type: type });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  document.body.appendChild(link)
    ;
  if (name && type !== 'application/pdf') {
    link.download = name;
  }
  link.click();
}

export { arrayBufferFromBase64, saveFile, openFile };


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/caseFiles.js